import type { Command } from 'commander';
import type { DuoCommand } from '../duo_command';
import type { ExitHandler } from '../../utils/exit';
import { MarketplaceGroupCommand } from './marketplace/marketplace_group_command';
import { PluginInstallCommand } from './plugin_install_command';
import { PluginListCommand } from './plugin_list_command';
import { PluginEnableCommand } from './plugin_enable_command';
import { PluginDisableCommand } from './plugin_disable_command';
import { PluginUninstallCommand } from './plugin_uninstall_command';
import { PluginUpdateCommand } from './plugin_update_command';
import { PluginContainerProvider } from './plugin_services';

export class PluginGroupCommand implements DuoCommand {
  readonly name = 'plugin';

  readonly description = 'Manage GitLab Duo plugins and marketplaces.';

  readonly children: DuoCommand[];

  readonly #containerProvider: PluginContainerProvider;

  constructor(exitHandler: ExitHandler) {
    // One container provider for the whole `plugin` subtree: built lazily on
    // first use and shared by every child command.
    const containerProvider = new PluginContainerProvider(exitHandler);
    this.#containerProvider = containerProvider;
    this.children = [
      new MarketplaceGroupCommand(containerProvider),
      new PluginInstallCommand(containerProvider),
      new PluginListCommand(containerProvider),
      new PluginEnableCommand(containerProvider),
      new PluginDisableCommand(containerProvider),
      new PluginUninstallCommand(containerProvider),
      new PluginUpdateCommand(containerProvider),
    ];
  }

  register(node: Command): void {
    // preAction fires after parsing and only when an action actually runs —
    // so `duo plugin marketplace --help` prints help without cloning the repo.
    node.hook('preAction', () => this.#containerProvider.ensureSeeded(node));
  }
}
